import List from '@material-ui/core/List';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import clsx from 'clsx';
import React, { useEffect, useState } from 'react';
import { useMediaQuery } from '@material-ui/core';
import FuseNavItem from '../FuseNavItem';

const useStyles = makeStyles(theme => ({
	navigation: {
		'& .fuse-list-item': {
			'&:hover': {
				backgroundColor: theme.palette.type === 'dark' ? 'rgba(255, 255, 255, 0.05)' : 'rgba(0,0,0,.04)'
			},
			'&:focus:not(.active)': {
				backgroundColor: theme.palette.type === 'dark' ? 'rgba(255, 255, 255, 0.06)' : 'rgba(0,0,0,.05)'
			}
		},
		'&.active-square-list': {
			'& .fuse-list-item, & .active.fuse-list-item': {
				width: '100%',
				borderRadius: '0'
			}
		},
		'&.dense': {
			'& .fuse-list-item': {
				paddingTop: 0,
				paddingBottom: 0,
				height: 32
			}
		}
	}
}));

function FuseNavVerticalLayout1(props) {
	const classes = useStyles(props);
	const theme = useTheme();
	const xsDown = useMediaQuery(theme.breakpoints.down('xs'));
	const { navigation, active, dense, className, onItemClick } = props;
	const [navigationList, setNavigationList] = useState(navigation);

	useEffect(()=>{
		const navList = navigation.filter(_item => !(['reoccurring-view'].includes(_item.id) && xsDown))
		setNavigationList(navList)
	},[xsDown, navigation])

	function handleItemClick(item) {
		onItemClick && onItemClick(item);
	}

	return (
		<List
			className={clsx(
				'navigation whitespace-nowrap px-12',
				classes.navigation,
				`active-${active}-list`,
				dense && 'dense',
				className
			)}
		>
			{navigationList.map(_item => (
				<FuseNavItem
					key={_item.id}
					type={`vertical-${_item.type}`}
					item={_item}
					nestedLevel={0}
					onItemClick={handleItemClick}
				/>
			))}
		</List>
	);
}

export default FuseNavVerticalLayout1;
